export default "__VITE_ASSET__ctiXqHzk__"